import { memberActionTypes } from '@Actions/memberActions';

const MemberReducer = (state = { }, action) => {
  switch (action.type) {
  case memberActionTypes.CREATE_MEMBER.LOADING: {
    const { createMemberLoading } = action;
    return {
      ...state,
      createMemberLoading,
    };
  }
  case memberActionTypes.UPDATE_MEMBER.LOADING: {
    const { updateMemberLoading } = action;
    return {
      ...state,
      updateMemberLoading,
    };
  }
  case memberActionTypes.GET_MEMBERS.LOADING: {
    const { getMembersLoading } = action;
    return {
      ...state,
      getMembersLoading,
    };
  }
  case memberActionTypes.GET_MEMBERS.SUCCESS: {
    const { members } = action;
    return {
      ...state,
      members,
    };
  }
  case memberActionTypes.DELETE_MEMBER.LOADING: {
    const { deleteMemberLoading } = action;
    return {
      ...state,
      deleteMemberLoading,
    };
  }
  case memberActionTypes.GET_TENANTS_ROLES.LOADING: {
    const { getTenantsRolesLoading } = action;
    return {
      ...state,
      getTenantsRolesLoading,
    };
  }
  case memberActionTypes.GET_TENANTS_ROLES.SUCCESS: {
    const { tenantsRoles } = action;
    return {
      ...state,
      tenantsRoles,
    };
  }
  default: {
    return state;
  }
  }
};

export default MemberReducer;
